import { toast } from 'react-toastify'

import { createAxiosInstance, getModificaciones, indexBy, esEntero } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import { displayMessages, uploadFiles } from './common'
import moment from 'moment';
import history from '../utils/history'
import FileDownload from 'react-file-download'

import { getSolicitud as getSolicitudOS } from './otrosi'




export function initReducer() {
	return (dispatch) => {
		dispatch({ type: types.REINICIAR_SOLICITUD_SERVICIO_OT1 })
	}
}

export function getSolicitud(id) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		axios.get(`${API_URL}/solicitudes/servicios-oficina-tecnica/${id}`)
		.then((res) => {
			const solicitud = res.data.solicitud
			const aprobadores = res.data.aprobadores
			dispatch({ type: types.OBTENER_SOLICITUD_SERVICIO_OT, payload: { solicitud,  aprobadores} })
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})
	}
}

export function registerApprovalResult(index, result) {
	
	const ip = require('ip');
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().solicitudservicioot.get('solicitud')			

		const modificaciones = []
		const aprobacion = solicitud.getIn(['cotizaciones', '0', 'aprobaciones', String(index)])
		
		modificaciones.push({
			id: aprobacion.get('id'),
			entity: 'Aprobacione',
			value: { estado: result, ip: ip.address(), observaciones: aprobacion.get('observaciones') },
			action: 'edit'
		})

		let errors = []
		solicitud.get('servicios').valueSeq().forEach(servicio => servicio.get('cencos').valueSeq().forEach(cenco => {

			if (modificaciones[0].value.estado !== 0  && cenco.get('rubros').count() > 0) {

				if (cenco.getIn(['pivot', 'rubro_id'])) {
					modificaciones.push({
						id: cenco.getIn(['pivot', 'id']),
						entity: 'DisCencoServicio',
						value: {
							rubro_id: cenco.getIn(['pivot', 'rubro_id'])
						},
						action: 'edit'
					});
				}

			}
		}))

		if (modificaciones[0].value.estado === 0 && !modificaciones[0].value.observaciones) {
			errors.push('Deben existir observaciones si va a rechazar esta aprobación')
		}

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})			
		} else {

			dispatch(({ type: types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT, payload: true }))

			axios.put(`${API_URL}/solicitudes/servicios-oficina-tecnica/${solicitud.get('id')}`, modificaciones)
				.then(res => {

					const solicitud = res.data.solicitud
					const aprobadores = res.data.aprobadores	

					if (solicitud.estado === 0) {
						history.push(window.FOLDER + '/solicitudes/abiertas')
						displayMessages(dispatch, { success: 'La solicitud ha sido anulada' })
					} else {						

						if (solicitud.documento_origen) {
							const fn1 = (d) => d(getSolicitudOS(solicitud.id))
							fn1(dispatch)
						}

						const fn0 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_SERVICIO_OT, payload: { solicitud, aprobadores} })
						fn0(dispatch)
						
						displayMessages(dispatch, { success: 'La solicitud ha sido guardada exitosamente' })
						dispatch(({ type: types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT, payload: false }))
					}
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					dispatch(({ type: types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT, payload: false }))
				})

		}
	}
}


export function crearAprobacionAdicional(aprobador, motivo) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
        const errors = validarSolicitudAprobacionAdicional(aprobador, motivo);
        if (errors.length > 0) {
            errors.forEach(x => {
                toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
            });
            return;
        }
        const solicitud = getState().solicitudservicioot.get('solicitud');
        const cotizacion = solicitud.getIn(['cotizaciones', '0']);
        const modificaciones = [];
        modificaciones.push({
            id: null,
            entity: 'Aprobacione',
            action: 'add',
            value: {
                cotizacion_id: cotizacion.get('id'),
                aprobador_id: aprobador.id,
                estado: 1, // Pendiente de aprobación
                observaciones: motivo,
                tipo: 3
            }
        });
        axios.put(`${API_URL}/solicitudes/servicios-oficina-tecnica/${solicitud.get('id')}`, modificaciones)
            .then(res => {
                dispatch(getSolicitud(solicitud.get('id')));
            })
            .catch(err => {
                displayMessages(dispatch, err);
            });
    };
}

export function displayModalCreateDocumento(show, title, mode, indexDocumento) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const proveedor = getState().solicitudservicioot.getIn(['solicitud', 'documentos', indexDocumento, 'proveedor_id'])
		const fn0 = () => axios.get(`${API_URL}/plantillas`)
		const fn1 = () => axios.get(`${API_URL}/garantias`)
		const fn2 = () => axios.get(`${API_URL}/documentos/contratos-anuales`, { params: { proveedor }})
		Promise.all([fn0(), fn1(), fn2()])
		.then(res => {
			const plantillas = res[0].data.data
			const garantias = res[1].data.data
			const contratos = res[2].data
			dispatch({ type: types.MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT, payload: { show, title, mode, indexDocumento, plantillas, garantias, contratos } })
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}




export function updateInputs(path, value, id = null, immutable = true) {
	return (dispatch) => {

		const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1, payload: { path, value, immutable } })
		fn0(dispatch)


		const pathArray = path.split('.')


		let entity = esEntero(pathArray.slice(-2)[0]) ? pathArray.slice(-3)[0] : pathArray.slice(-2)[0]
		const attribute = pathArray.slice(-2)[1]

		switch (entity) {	
			
			
			case 'solicitud':
				entity = 'Solicitude'
			break

			case 'servicios':
				entity = 'Servicio'
			break


		}

		if (id) {
			const fn2 = (d) => d({ type: types.ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT, payload: { id, entity, attribute, value, action: 'edit' } })
			fn2(dispatch)
		}


	}
}



export function seleccionarProveedor(payload) {
	return (dispatch) => {
		dispatch(updateInputs(payload.path, payload.value, payload.value.id))
	}
}


export function displayModalAddServicio(show, title, mode, index) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1, payload: { show, title, mode, index } })
		} else {
			dispatch({ type: types.OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1 })
		}
	}
}

export function addSolicitudServicioItem() {
	return (dispatch, getState) => {

		const data = getState().solicitudservicioot.getIn(['modalAddServicio', 'data'])
		const errors = []

		if (!data.get('descripcion')) errors.push('La creación de servicios requiere de una descripción')
		if (data.get('cotizado') < 0) errors.push('La creación de servicios requiere que el valor del servicio sin IVA sea superior a 0')
		if (data.get('cotizado_iva') < 0) errors.push('La creación de servicios requiere que el valor total sea superior a 0')
		if (Number(data.get('cotizado_iva')) < Number(data.get('cotizado'))) errors.push('El valor total debe ser igual o superior al valor sin IVA')
		
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT1 })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1 })

			const fn3 = (d) => d({ type: types.ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT, payload: { 
				id: getState().solicitudservicioot.get('id'), 
				entity: 'Solicitud', 
				attribute: 'servicios', 
				value: 'array', 
				action: 'edit' 
			} })

			fn1(dispatch)
			fn2(dispatch)
			fn3(dispatch)


		}
	}
}




export function addGarantia(checked, index, id) {
	return (dispatch) => {
		if (checked) {
			dispatch({ type: types.ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT, payload: index })
		} else {
			dispatch({ type: types.REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT, payload: id })
		}
	}
}

export function createOrUpdateDocumento() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT, payload: true }) //No aparece en actions creators
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT, payload: false })
		fn0(dispatch)
		const fn3 = (d) => d(displayModalCreateDocumento(false))
		const solicitud = getState().solicitudservicioot.get('id')
		const data = getState().solicitudservicioot.get('modalCreateDocumento')	

		let documentoNew = data.get('data')
		let documentoOld = data.get('unchanged')
		const tipoDocumento = documentoNew.get('tipo')
		
		if ((tipoDocumento == 1) || (tipoDocumento == 3)) {
			documentoNew = documentoNew.set('fecha_inicio', moment().format('YYYY-MM-DD'))
		}

		if (tipoDocumento == 4) {
			const fecha_inicio = getState().solicitudservicioot.getIn(['solicitud', 'documento_origen', 'fecha_inicio'])
			documentoNew = documentoNew.set('fecha_inicio', moment(fecha_inicio).format('YYYY-MM-DD'))
		}

		const errors = validateDocumento(documentoNew, data.get('contratoanual'))





		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
			fn1(dispatch)
		} else {
			documentoOld = documentoOld.set('garantias', indexBy(documentoOld.get('garantias'), 'id'))
			documentoNew = documentoNew.set('garantias', indexBy(documentoNew.get('garantias'), 'id'))
			const modificaciones = getModificaciones(documentoNew, documentoOld, 'Documento', switchDocumento)
			const mode = getState().solicitudservicioot.getIn(['modalCreateDocumento', 'mode'])

			if (mode === 'create') {

			} else if (mode === 'edit') {

				modificaciones.push({
					id: getState().solicitudservicioot.get('id'),
					entity: 'Solicitude',
					attribute: 'fecha_requerido',
					value: documentoNew.get('fecha_entrega'),
					action: 'edit'
				})

				axios.put(`${API_URL}/solicitudes/servicios-oficina-tecnica/${solicitud}`, modificaciones)
					.then(res => {
						const solicitud = res.data.solicitud
						const aprobadores = res.data.aprobadores						
						const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_SERVICIO_OT, payload: { solicitud, aprobadores} })
						fn1(dispatch)
						fn2(dispatch)
						fn3(dispatch)
						displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
					})
					.catch(err => {
						console.log(err)
						displayMessages(dispatch, err)
						fn1(dispatch)
					})


			}
		}
	}
}





export function registerCancelacion() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {

        const solicitud = getState().solicitudservicioot.get('solicitud').set('estado', 0)
        const errors = validateSolicitud(solicitud)

        if (errors.length > 0) {
            errors.forEach(x => {
                toast.warning(x, {
                    bodyClassName: 'toastify-content toastify-warning'
                })
            })
        } else {
            const modificaciones = []
            modificaciones.push({
                id: solicitud.get('id'),
                entity: 'Solicitude',
                value: {
                    estado: 0,
                    motivo_cancelacion: solicitud.get('motivo_cancelacion'),
                    fecha_cancelacion: moment().format('YYYY-MM-DD')
                },
                action: 'edit'
            })

            axios.put(`${API_URL}/solicitudes/servicios-oficina-tecnica/${solicitud.get('id')}`, modificaciones)
                .then(res => {
                    const solicitud = res.data.solicitud
                    const aprobadores = res.data.aprobadores
                    const fn0 = (d) => d({
                        type: types.ACTUALIZAR_SOLICITUD_SERVICIO_OT,
                        payload: {
                            solicitud,
                            aprobadores
                        }
                    })
                    const fn1 = () => toast.success('Los cambios han sido guardados exitosamente', {
                        bodyClassName: 'toastify-content toastify-success'
                    })
                    fn0(dispatch)
					fn1()
					
					if (solicitud.documento_origen) {
						const fn2 = (d) => d(getSolicitudOS(solicitud.id))
						fn2(dispatch)
					}		
					
                })
                .catch(err => {
                    console.log(err)
                    displayMessages(dispatch, err)
                })
        }
    }
}

export function resetAIU() {
	return {
		type: types.REINICIAR_VALORES_AIU
	}
}

export function resetIVA() {
	return {
		type: types.REINICIAR_VALORES_IVA
	}
}






export function addFile(url, actions) {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile','data'])
		const files = [data]
		dispatch(uploadFiles(url, files, actions))
	}
}

export function removeFiles() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const fns = []
		const selectedFiles = getState().solicitudservicioot.getIn(['solicitud', 'adjuntos']).filter(a => a.get('id') && a.get('selected')).map(a => {
			fns.push(() => axios.delete(`${API_URL}/files/${a.get('id')}`))
		})
		Promise.all(fns.map(x => x()))
		.then(res => {
			dispatch({ type: types.ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT1 })
			displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}


export function previewDocumento(id) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const documento = getState().solicitudservicioot.getIn(['modalCreateDocumento', 'data'])
		const tipo = getState().common.getIn(['enums', 'documentos', 'tipos', `${documento.get('tipo')}`, 'NOMBRE'])

		axios.post(`${API_URL}/solicitudes/servicios-oficina-tecnica/view/${id}`, {documento}, { responseType: 'arraybuffer' })
		.then(res => {			
			FileDownload(res.data, `PREV-${tipo}.pdf`);
		})
		.catch(err => {			
			const decodedString = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data)))
			const obj = {
				response: {
					data: decodedString,
					status: 422
				}
			}
			displayMessages(dispatch, obj)
		})
	}
}

const switchForo = (change, modificacion, foros) => {

	
	switch (change.get('op')) {
		
		case 'add':
			delete modificacion.attribute;
			delete modificacion.value.usuario;
		break

		case 'replace':
			modificacion.action = 'edit';
			modificacion.attribute = modificacion.attribute[1]
		break

	}
	
}


export function updateSolicitud() {
	
	const axios = createAxiosInstance()

	return (dispatch, getState) => {

		// const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO, payload: true })
		// const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO, payload: false })
		// fn0(dispatch)

		const id = getState().solicitudservicioot.get('id')
		const solicitud = getState().solicitudservicioot.get('solicitud')
		const unchaged = getState().solicitudservicioot.get('unchaged')
		const modificar = getState().solicitudservicioot.get('addModificacion')


		//const errors = validateSolicitud(solicitud)
		const errors = []

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			let modificaciones = []

			if (modificar) {
				modificaciones = addModificacion(solicitud)
			}


			axios.put(`${API_URL}/solicitudes/servicios-oficina-tecnica/${id}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores

				const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_SERVICIO_OT, payload: { solicitud, aprobadores } })
				const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas')
				const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })

				fn2(dispatch)
				fn3()
				fn4()
			

			})
			.catch(err => {
				displayMessages(dispatch, err)
				//fn1(dispatch)
			})



			

		}

	}
}


export function removeSolicitudServicioItems() {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {

        const solicitud = getState().solicitudservicioot.getIn(['solicitud', 'id'])

        const servicios = getState().solicitudservicioot.getIn(['solicitud', 'servicios']).filter(x => x.get('id') && x.get('selected'))

        const modificaciones = []

        servicios.valueSeq().forEach(servicio => {

            const cencos = servicio.get('cencos')

            cencos.valueSeq().forEach(c => {
                modificaciones.push({
                    entity: 'DisCencoServicio',
                    id: c.getIn(['pivot', 'id']),
                    action: 'delete'
                })
            })

            modificaciones.push({
                entity: 'Servicio',
                id: servicio.get('id'),
                action: 'delete'
            })

        })

        axios.put(`${API_URL}/solicitudes/servicios-oficina-tecnica/${solicitud}`, modificaciones)
        .then(res => {
            const solicitud = res.data.solicitud
            const aprobadores = res.data.aprobadores					
            const fn1 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_SERVICIO_OT, payload: { solicitud, aprobadores }})
            fn1(dispatch)
            displayMessages(dispatch, { success: 'La eliminacion han sido realizada exitosamente' })
        })
        .catch(err => {
            displayMessages(dispatch, err)
        })
		
	}
}


export function seleccionarMoneda(moneda='COP') {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.SELECCIONAR_MONEDA_SOLICITUD_OT1, payload: { moneda } })
		fn1(dispatch)		
		const fn2 = (d) => d({ type: types.ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT, payload: { id:0, entity: 'Cotizacione', attribute: 'moneda', value: moneda, action: 'edit' } })
		fn2(dispatch)
	}
}


export function enviarComentario() {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud_id = getState().solicitudservicioot.getIn(['solicitud', 'id'])
		const usuario_id = getState().common.getIn(['user', 'id'])
		const id = getState().solicitudservicioot.getIn(['comentario','id'])
		const comentario = getState().solicitudservicioot.getIn(['comentario','texto'])
        const modificaciones = []

		if (id == null) {

			modificaciones.push({ 
				entity: 'Foro', 
				action: 'add', 
				id: null,
				value: {
					solicitud_id,
					usuario_id,
					comentario
				}
			})

		} else {

			modificaciones.push({
				id,
				entity: 'Foro',
				value: { comentario },
				action: 'edit'
			})
		}

		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1, payload: true })
		const fn2 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1, payload: false })

		fn1(dispatch)
		axios.put(`${API_URL}/solicitudes/servicios-oficina-tecnica/${solicitud_id}`, modificaciones)
		.then(res => {
			const foros = res.data.solicitud.foros	
			const fn3 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1, payload: { foros } })
			fn3(dispatch)
			fn2(dispatch)
		})
		.catch(err => {
			displayMessages(dispatch, err)
			fn2(dispatch)
		})		
	}
}

export function editarComentario( id ) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_OT1, payload: { id } })
		fn1(dispatch)
	}
}

export function eliminarComentario(id) {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud = getState().solicitudservicioot.getIn(['solicitud', 'id'])
        const modificaciones = []
		modificaciones.push({ entity: 'Foro', id, action: 'delete'})
        axios.put(`${API_URL}/solicitudes/servicios-oficina-tecnica/${solicitud}`, modificaciones)
        .then(res => {
			const foros = res.data.solicitud.foros	
			const fn1 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1, payload: { foros } })
            fn1(dispatch)
			displayMessages(dispatch, { success: 'La eliminacion han sido realizadas exitosamente' })
        })
        .catch(err => {
            displayMessages(dispatch, err)
        })		
	}
}


///******* Shared ********///


const validateSolicitud = (data) => {
	const errors = []
	if (data.get('estado') == 0 && !data.get('motivo_cancelacion')) errors.push('El campo motivo cancelación es obligatorio')
	return errors
}




const validateDocumento = (data, escontratoanual=false) => {
	const errors = []
	
	if (Number(data.get('tipo')) === 0) errors.push('El campo tipo de documento es obligatorio')
	if (data.get('tipo') == 2 && !data.get('fecha_inicio')) errors.push('El campo fecha inicio es obligatorio')
	if (!data.get('fecha_entrega')) errors.push('El campo fecha entrega es obligatorio')

	if (data.get('tipo') == 2 && data.get('fecha_inicio')) {

		if (moment().subtract(1,'day').isAfter(data.get('fecha_inicio'))) errors.push('La fecha de inicio no debe ser inferior a hoy')

	}

	if (data.get('tipo') == 2 && data.get('fecha_inicio') && data.get('fecha_entrega')) {
		if (moment(data.get('fecha_inicio')).isAfter(data.get('fecha_entrega'))) errors.push('La fecha entrega no debe ser inferior a la fecha de inicio')
	}

	if (data.get('tipo') != 4 && Number(data.get('plantilla_id')) === 0) errors.push('El campo plantilla es obligatorio')
	if (Number(data.get('anticipo')) > 50) errors.push('El anticipo no debe ser superior al 50%')
	if (Number(data.get('anticipo')) > 0 && !data.get('pago_anticipo')) errors.push('La fecha de pago de anticipo es obligatioria si hay anticipo')
	if (Number(data.get('anticipo')) > 0 && !data.get('forma_pago_anticipo')) errors.push('La forma de pago de anticipo es obligatioria si hay anticipo')


	if (escontratoanual) {
		if (Number(data.get('documento_id')) === 0) errors.push('El campo número de contrato es obligatorio')
	}


	const margen_err = 1
	const iva_input = parseFloat(Number(data.getIn(['cotizacion', 'cotizado_iva'])).toFixed(2))
	const valor = parseFloat(Number(data.get('aiu_total')).toFixed(2))

	//No borrar.
	// if (data.get('iva') == 0 && data.getIn(['cotizacion', 'cotizado_iva']) !== data.get('aiu_total') && data.get('tipo') != 4) {
	// 	errors.push('El valor total de los servicios es diferente al valor total del AIU')
	// }


	//No borrar.
	// if (data.get('iva') != 0 && data.getIn(['cotizacion', 'cotizado_iva']) !== data.get('aiu_total') && data.get('tipo') != 4) {
	// 	errors.push('El valor total de los servicios es diferente al valor total del IVA')
	// }


	//Lo mando a quitar Oscar el dia 12/07/2019 via Skype
	// if (data.get('iva') != 0 && data.get('tipo') != 4) {
	// 	if ( iva_input < valor - 1 || iva_input > valor + 1) errors.push('El valor total de los servicios es diferente al valor total del IVA')		
	// }


	//Lo mando a quitar Oscar el dia 12/07/2019 via Skype
	// if (data.get('iva') == 0 && data.get('tipo') != 4) {
	// 	if ( iva_input < valor - 1 || iva_input > valor + 1) errors.push('El valor total de los servicios es diferente al valor total del AIU')
	// }



	if (!data.get('almacen')) {
		errors.push('El campo Almacén es obligatorio')
	}



	
	return errors
}

export const validarSolicitudAprobacionAdicional = (aprobador, motivo) => {
    const errors = [];
    if (!aprobador || !aprobador.id) errors.push('Debe seleccionar un aprobador adicional');
    if (!motivo || !motivo.trim()) errors.push('El motivo de la solicitud adicional es obligatorio');
    return errors;
}

const switchDocumento = (change, modificacion, documento) => {

	const path = [...modificacion.attribute]
	
	modificacion.attribute = path[0]
	
	switch (modificacion.attribute) {
		case 'aiu_administracion_value':
		case 'aiu_imprevistos_value':
		case 'aiu_utilidad_value':
		case 'aiu_iva_utilidad_value':
		case 'iva_value':
		case 'aiu_total':
		case 'todos_detalles':
			modificacion.action = 'hidden'
		break
	}

    switch (change.get('op')) {
        case 'add':
            if (modificacion.attribute === 'garantias') {
                modificacion.value = modificacion.value.id
                modificacion.action = 'attach'
            }
			break
			
		case 'replace':	
            if (modificacion.attribute === 'cotizacion') {
				modificacion.entity = 'Cotizacione'				
				modificacion.id = documento.getIn(['cotizacion', 'id'])
				if (path[1] == 'cotizado_iva') {
					modificacion.attribute = 'cotizado_iva'
					modificacion.value = documento.getIn(['cotizacion', 'cotizado_iva'])
				}

            }
            break


        case 'remove':
            if (modificacion.attribute === 'garantias') {
				modificacion.action = 'detach'
            }
            break
    }
}



const addModificacion = (solicitud) => {


	const modificaciones = []

	modificaciones.push({
		id: solicitud.get('id'),
		entity: 'Solicitude',
		value: {
			proyecto_evento: solicitud.get('proyecto_evento'),
			fecha_requerido: solicitud.get('fecha_requerido')
		},
		action: 'edit'
	})

	if (solicitud.get('cotizaciones')) {
		for(let idx = 0; idx < solicitud.get('cotizaciones').count(); idx++) {
			modificaciones.push({
				id: solicitud.getIn(['cotizaciones', idx, 'id']),
				entity: 'Cotizacione',
				value: {
					proveedor_id: solicitud.getIn(['cotizaciones', 0, 'proveedore', 'id']),
					moneda: solicitud.getIn(['cotizaciones', 0, 'moneda'])
				},
				action: 'edit'
			})
		}
	}

	solicitud.get('servicios').valueSeq().forEach(servicio => {

		if (servicio.get('id')) {
			modificaciones.push({
				id: servicio.get('id'),
				entity: 'Servicio',
				value: {
					descripcion: servicio.get('descripcion'),
					valor: servicio.get('valor'),
					valor_con_iva: servicio.get('valor_con_iva')
				},
				action: 'edit'
			})
			
		} else {

			modificaciones.push({
				entity: 'Servicio',
				value: {
					descripcion: servicio.get('descripcion'),
					valor: servicio.get('valor'),
					valor_con_iva: servicio.get('valor_con_iva'),
					cantidad: 1,
					solicitud_id: solicitud.get('id'),
					estado: 1
				},
				action: 'add'
			})


		}
	})

	return modificaciones

}




// WEBPACK FOOTER //
// ./src/actions/solicitudservicioot.js